import React from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import find from "lodash/find";
import { Link } from "react-router-dom";
import { Icon, Menu, Select, Tooltip } from "antd";
import { withRouter } from "react-router";
import classNames from "classnames";

// import logoDefault from "../../assets/img/diamind_logo.png";

import classes from "./AdminHeader.css";

import {
  getUserToken,
  getPatientProfileReadPermission,
  getSAEReadPermission,
  getFollowUp7dReadPermission,
  getFollowUp30dReadPermission,
  getAdminSettingsPermission,
  getUserInfo,
  getLanguages,
  getSiteReadPermission,
  getRoleReadPermission,
  getUserReadPermission,
  getDocumentReadPermission,
  getDocumentTrainingReadPermission,
  getDocumentPublicReadPermission,
  getAuditLogReadPermission,
  getSimulationReadPermission,
  getDrugAccessPermissionInEnrollment,
  getDrugAccessPermissionInEventSummary,
  getDrugAccessPermissionDrugManagement,
  getDrugAccessPermissionRandomization,
  getDrugReadPermission,
  getPatientProfileCreatePermission,
  getSubjectProfileUploadReadPermission,
  getUnblindingRequestCreatePermission,
  getUnblindingRequestReadPermission,
  getUnblindingRequestApprovePermission,
  getReportsReadPermission,
  getRandomizationAccessPermission,
  getScheduledSubjectReadPermission,
  getFinanceReadPermission,
  getFinanceInvoiceReadPermission,
  getFinanceCustomerReadPermission,
  getFinanceEventReadPermission,
  getFinanceInvoiceGeneratedEventReadPermission,
  getMyProfileReadPermission,
  getPermissions,
  getDocumentPharmacyBinderPermission,
  getDocumentStudyRegulatoryBinderPermission,
  getValidateRandomizationAccessPermission,
  getNewsletterReadPermission,
  getCustomFormsReadPermission,
  getDrugManagementStatus,
  getProjectConfigurationStatus,
  getUserInfoRoles,
} from "../../reducers/user/selectors";
import { logout, updateUserLanguage } from "../../reducers/user/actions";
import { withParams } from "../../utils/url";

import { withNamespaces } from "react-i18next";
import { getTheme } from "../../reducers/theme/selectors";

const routes = require("../../routes.json");

class AdminHeader extends React.Component {
  state = {
    mobileMenuVisible: false,
  };

  render() {
    const {
      logout,
      adminSettingsPermission,
      userInfo,
      permissions,
    } = this.props;

    return (
      <div className={classes.header}>
        <div className={classes.headerTop}>
          <Link to="/admin" className={classes.headerProfileLogo}>
            <img
              alt="diamond-trial-logo"
              src={this.props.theme.logo_dark}
              style={{
                objectFit: "contain",
                width: "auto",
                height: "25px",
                margin: "8px 16px 0 5px",
              }}
            />
            {this.props.i18n.t("NamespaceAdminHeader:DCTMS Trial")}
          </Link>

          <div className={classes.headerTopRight}>
            {this.props.languages.length > 0 &&
              !this.props.userInfoRoles.includes("Patient") && (
                <Select
                  onChange={(value) =>
                    this.props.updateUserLanguage({
                      id: value,
                      code: get(
                        find(this.props.languages, ({ id }) => id === value),
                        "code"
                      ),
                    })
                  }
                  value={userInfo.language || this.props.languages[0].id}
                  placeholder={this.props.i18n.t("Language")}
                  style={{ width: "9.5rem", marginRight: "1rem" }}
                >
                  {this.props.languages.map((language) => (
                    <Select.Option key={language.id} value={language.id}>
                      <img
                        src={`https://flagcdn.com/16x12/${
                          language.code === "en" ? "us" : language.code
                        }.png`}
                        alt={language.code}
                      />{" "}
                      {language.name}
                    </Select.Option>
                  ))}
                </Select>
              )}

            {!this.props.userInfoRoles.includes("Patient") && (
              <span className={classes.headerProfileUsername}>
                {this.props.i18n.t("Welcome")},{" "}
                {get(userInfo, "first_name")
                  ? `${get(userInfo, "first_name")}`
                  : get(userInfo, "email")}
                &nbsp; |&nbsp;
                {permissions &&
                  permissions.reduce(function (n, item) {
                    return (
                      n +
                      (get(item, "user_role.randomization_access") &&
                        get(item, "site.site_type") === "randomization" &&
                        get(item, "site.randomization_permitted"))
                    );
                  }, 0) === 0 && <span>{this.props.i18n.t("NamespaceAdminHeader:No Randomization Sites")}</span>}
                {permissions &&
                  permissions.reduce(function (n, item) {
                    return (
                      n +
                      (get(item, "user_role.randomization_access") &&
                        get(item, "site.site_type") === "randomization" &&
                        get(item, "site.randomization_permitted"))
                    );
                  }, 0) === 1 && (
                    <span>
                      Site:{" "}
                      {get(
                        permissions.filter(function (item) {
                          return (
                            get(item, "user_role.randomization_access") &&
                            get(item, "site.site_type") === "randomization" &&
                            get(item, "site.randomization_permitted")
                          );
                        })[0],
                        "site.name"
                      )}
                    </span>
                  )}
                {permissions &&
                  permissions.reduce(function (n, item) {
                    return (
                      n +
                      (get(item, "user_role.randomization_access") &&
                        get(item, "site.site_type") === "randomization" &&
                        get(item, "site.randomization_permitted"))
                    );
                  }, 0) > 1 && <span>{this.props.i18n.t("NamespaceAdminHeader:Multiple Randomization Sites")}</span>}
              </span>
            )}

            <div className={classes.headerTopRightMenu}>
              {!this.props.userInfoRoles.includes("Patient") && (
                <Menu
                  mode="horizontal"
                  selectedKeys={[
                    this.props.location.pathname.includes(routes.admin.settings)
                      ? "adminSettings"
                      : "",
                    this.props.location.pathname.includes(
                      routes.admin.myProfile
                    )
                      ? "myProfile"
                      : "",
                  ]}
                >
                  {adminSettingsPermission && (
                    <Menu.Item key="adminSettings">
                      <Link
                        to={routes.admin.settings}
                        className={classNames(classes.headerProfileLink)}
                      >
                        <Icon type="setting" />
                        {this.props.i18n.t("Admin settings")}
                      </Link>
                    </Menu.Item>
                  )}
                  {this.props.myProfileReadPermission && (
                    <Menu.Item key="myProfile">
                      <Link
                        to={routes.admin.myProfile}
                        className={classNames(classes.headerProfileLink)}
                      >
                        <Icon type="user" />
                        {this.props.i18n.t("My Profile")}
                      </Link>
                    </Menu.Item>
                  )}
                </Menu>
              )}

              <Tooltip placement="topLeft" title={this.props.i18n.t("Logout")}>
                <button
                  type="button"
                  className={classes.logout}
                  onClick={logout}
                >
                  <Icon type="logout" />
                </button>
              </Tooltip>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  token: getUserToken(state),
  patientProfileReadPermission: getPatientProfileReadPermission(state),
  patientProfileCreatePermission: getPatientProfileCreatePermission(state),
  SAEReadPermission: getSAEReadPermission(state),
  followUp7dReadPermission: getFollowUp7dReadPermission(state),
  followUp30dReadPermission: getFollowUp30dReadPermission(state),
  adminSettingsPermission: getAdminSettingsPermission(state),
  userInfo: getUserInfo(state),
  languages: getLanguages(state),
  simulationReadPermission: getSimulationReadPermission(state),
  siteReadPermission: getSiteReadPermission(state),
  roleReadPermission: getRoleReadPermission(state),
  userReadPermission: getUserReadPermission(state),
  subjectProfileUploadReadPermission: getSubjectProfileUploadReadPermission(
    state
  ),
  unblindingRequestCreatePermission: getUnblindingRequestCreatePermission(
    state
  ),
  unblindingRequestApprovePermission: getUnblindingRequestApprovePermission(
    state
  ),
  unblindingRequestReadPermission: getUnblindingRequestReadPermission(state),
  documentReadPermission: getDocumentReadPermission(state),
  documentTrainingReadPermission: getDocumentTrainingReadPermission(state),
  documentPublicReadPermission: getDocumentPublicReadPermission(state),
  auditLogReadPermission: getAuditLogReadPermission(state),
  drugAccessPermissionInEnrollment: getDrugAccessPermissionInEnrollment(state),
  drugAccessPermissionInEventSummary: getDrugAccessPermissionInEventSummary(
    state
  ),
  drugAccessPermissionDrugManagement: getDrugAccessPermissionDrugManagement(
    state
  ),
  drugAccessPermissionRandomization: getDrugAccessPermissionRandomization(
    state
  ),
  drugReadPermissions: getDrugReadPermission(state),
  reportsReadPermission: getReportsReadPermission(state),
  randomizationAccessPermission: getRandomizationAccessPermission(state),
  scheduledSubjectReadPermission: getScheduledSubjectReadPermission(state),
  financeReadPermission: getFinanceReadPermission(state),
  financeCustomerReadPermission: getFinanceCustomerReadPermission(state),
  financeInvoiceReadPermission: getFinanceInvoiceReadPermission(state),
  financeEventReadPermission: getFinanceEventReadPermission(state),
  financeInvoiceGeneratedEventReadPermission: getFinanceInvoiceGeneratedEventReadPermission(
    state
  ),
  myProfileReadPermission: getMyProfileReadPermission(state),
  permissions: getPermissions(state),
  documentPharmacyBinderPermission: getDocumentPharmacyBinderPermission(state),
  documentStudyRegulatoryBinderPermission: getDocumentStudyRegulatoryBinderPermission(
    state
  ),
  validateRandomizationAccessPermission: getValidateRandomizationAccessPermission(
    state
  ),
  newsletterReadPermission: getNewsletterReadPermission(state),
  customFormsReadPermission: getCustomFormsReadPermission(state),
  theme: getTheme(state),
  isDrugManagementActive: getDrugManagementStatus(state),
  isProjectConfigurationActive: getProjectConfigurationStatus(state),
  userInfoRoles: getUserInfoRoles(state),
});
const mapDispatchToProps = {
  logout,
  updateUserLanguage,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withNamespaces()(AdminHeader)));



// WEBPACK FOOTER //
// ./src/components/AdminHeader/AdminHeader.js